import { Box, type BoxProps } from "@chakra-ui/react";
import { MultiSelect } from "react-multi-select-component";

type SelectOption = {
	label: string;
	value: string;
};

type InputTagsProps = {
	options: SelectOption[];
	selected: SelectOption[];
	setSelected: (options: SelectOption[]) => void;
};

const InputTags = ({
	options,
	selected,
	setSelected,
	...props
}: InputTagsProps & BoxProps) => {
	return (
		<Box position="relative" {...props}>
			<MultiSelect
				options={options}
				value={selected}
				onChange={setSelected}
				labelledBy={""}
			/>
		</Box>
	);
};

export default InputTags;
